import PropTypes from 'prop-types';
import React, {Component} from 'react';
import CrumbName from './CrumbName';
import LinkedCrumb from './LinkedCrumb';
import './Breadcrumbs.less';

class Breadcrumbs extends Component {
    static propTypes = {
        /** aria-label for breadcrumb. A useful descriptor like "You are here:" */
        ariaLabel: PropTypes.string.isRequired,
        /** Array of urls, text to display in breadcrumb */
        crumbs: PropTypes.arrayOf(PropTypes.shape({
            url: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired
        })),
        /** If true, the last crumb will act like the other crumbs, with navigation behavior to specified url. */
        isLastCrumbLinked: PropTypes.bool,
        /** Event handler triggered whenever a linked crumb is clicked. Passes the event and the targeted crumb data */
        onClickCrumbName: PropTypes.func
    };

    static defaultProps = {
        ariaLabel: 'You are here:',
        crumbs: [],
        onClickCrumbName: () => {}
    }

    handleCrumbNameClick(crumb) {
        return (event) => {
            this.props.onClickCrumbName(event, crumb);
        };
    }

    render() {
        const {ariaLabel, crumbs, isLastCrumbLinked, ...rest} = this.props;
        const hasCrumbs = (crumbs.length > 0);
        const lastCrumb = crumbs[crumbs.length - 1];
        delete rest.onClickCrumbName;
        return (
            <nav aria-label={ariaLabel} {...rest}>
                {hasCrumbs &&
                    <ol id="breadcrumb" className="Breadcrumb" itemScope itemType="https://schema.org/BreadcrumbList">
                        {crumbs
                            .filter((crumb) => isLastCrumbLinked || crumb !== lastCrumb)
                            .map((crumb, index) => (
                                <LinkedCrumb
                                    key={index}
                                    hasDivider={index !== crumbs.length - 1}
                                    currentPage={index === crumbs.length - 1}
                                    onClickName={this.handleCrumbNameClick(crumb)}
                                    url={crumb.url}
                                    name={crumb.name}
                                    position={index + 1}
                                />)
                            )
                        }
                        {!isLastCrumbLinked &&
                            <li className="Breadcrumb__li Breadcrumb__li--active" itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
                                <CrumbName name={lastCrumb.name} />
                                <span itemProp="position" content={crumbs.length} aria-hidden/>
                            </li>
                        }
                    </ol>
                }
            </nav>
        );
    }
}

export default Breadcrumbs;
